<div class="map home-block">
  <div class="home-container">
    <div id="copyright-line">
      <span
        >Copyright {{ copyrightYear }} PC Trade Systems Kft. All rights reserved. Created by</span
      >
      <a href="http://plaveoo.hu/" target="_blank">
        <img
          alt="plaveoo-logo"
          height="40"
          loading="lazy"
          src="/multimedia/home/plaveoo-logo.webp"
          width="120"
        />
      </a>
      <a href="/docs/adatkezelesi_tajekoztato.pdf" target="_blank">Adatkezelési tájékoztató</a>
    </div>
  </div>
</div>
